import React from 'react';
import UnifiedMessageCustomerModal from './UnifiedMessageCustomerModal';
import { sendSmsToCustomer } from '../../../services/BackendService';
import { ICustomer } from '../types';

interface IProps {
  show: boolean;
  onClose: () => void;
  onCloseDiscardChanges: () => void;
  customer: ICustomer;
}

const SmsCustomerModal = ({ show, onClose, onCloseDiscardChanges, customer }: IProps) => {
  return (
    <UnifiedMessageCustomerModal
      show={show}
      onClose={onClose}
      onCloseDiscardChanges={onCloseDiscardChanges}
      customer={customer}
      titleKey="customer.send-sms-to"
      successToastKey="customer.sms-sent-to-customer"
      inputId="sms-message"
      showSubject={false}
      onSend={({ customerId, message }) => sendSmsToCustomer(customerId, message)}
    />
  );
};

export default React.memo(SmsCustomerModal);
